export function storesURL() {
    return '/vmpws/v2/vmp/stores';
}

export function storeURL(storeId: string) {
    return `/vmpws/v2/vmp/stores/${storeId}`;
}

export function autocompleteURL(query: string) {
    return `/vmpws/v2/vmp/stores/autocomplete?query=${query}`;
}
